'use strict';

export default function getHeader() {
    return {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': true,
        'Access-Control-Allow-Origin:': '*',
        'Access-Control-Allow-Methods': 'GET, POST',
        'Access-Control-Allow-Headers': 'X-Requested-With, Content-Type, Authorization, Cache-Control',
        'Access-Control-Allow-Credentials': true
    }
 }